'use client'

import { Swiper, SwiperSlide } from 'swiper/react';
import Image from 'next/image';
import { CarSourceItem } from '../api';

import 'swiper/css';

interface Props {
  albums?: string[];
  videoData?: CarSourceItem[];
}
export default function Index({ albums = [], videoData }: Props) {

  const items = albums.map((v, index) => (
    <SwiperSlide key={index}>
      <Image alt='' width={375} height={241} src={v} style={{width: '100%', height: 'auto'}} />
    </SwiperSlide>
  ));

  if (videoData?.length) {
    items.unshift(
      <SwiperSlide>
        <video controls preload="metadata" loop={false}  poster="" style={{ width: '100%', height: 'auto' }}>
          <source src={videoData?.[0].url} type="video/mp4" />
          {/* <source src="/videos/my-video.webm" type="video/webm" /> */}
          您的浏览器不支持视频播放。
        </video>
      </SwiperSlide>,
    );
  }
  return (
    <Swiper loop>
      {items}
    </Swiper>
  );
}
